import { getCookie, setCookie } from "Functions/cookie";

$('.js-form-country-change [name="country_id"]').on("change", function () {
    $(this).parents("form").submit();
});

$(".js-form-country-change").validate({
    submitHandler: function (form) {
        document.querySelectorAll(".js-toggle-trigger-country-change").forEach(function (el) {
            el.classList.add("is-loading");
        });

        Form.ajaxPost(
            form,
            function (data) {
                Eshop.alert(data.msg, {
                    type: data.status ? "success" : "error",
                });

                if (data.status) {
                    document.querySelectorAll(".js-toggle-country-change").forEach(function (el) {
                        el.handleToggle(false);
                    });
                    setCookie("country_selected", "1", 30);
                    window.location.reload();
                } else {
                    document
                        .querySelectorAll(".js-toggle-trigger-country-change")
                        .forEach(function (el) {
                            el.classList.remove("is-loading");
                        });
                }
            },
            "json"
        );
    },
});

const countryRedirects = {
    1: "https://www.svetnapojov.sk",
    56: "https://www.svetnapoju.cz",
};

$(".js-country-input").on("change", function () {
    var value = $(this).val();

    if ($("html").attr("lang") == "en" && countryRedirects[value]) {
        window.location.href = countryRedirects[value] + "/nakupny-kosik";

        return;
    }

    if ($("html").attr("lang") == "en") {
        // zmenit krajinu
        $.ajax({
            url: "/zmena-krajiny",
            type: "POST",
            dataType: "json",
            data: { country_id: value },
        }).done(function (data) {
            Eshop.alert(data.msg, {
                type: data.status ? "success" : "error",
            });
            location.reload();
        });
    }
});

if (getCookie("country_selected") !== "1") {
    $("#country-select-modal").modal("show");
}
